import { Button, Divider, DrawerBody, DrawerHeader, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DrawerFixedButton } from 'components/Drawer';
import { EmployeeGroupInfiniteList } from 'components/InfiniteScroll';
import EmployeeList from 'components/List/EmployeeList';
import { useBulkAssignEmployeesAndGroups } from 'hooks/jobs/useBulkAssignEmployeesAndGroups';

import { initialAssignEmployeesAndGroupsData } from './schema';

interface IAssignEmployeesAndGroupsFormProps {
  formData: typeof initialAssignEmployeesAndGroupsData;
  onClose: (postData?: any) => void;
}

const AssignEmployeesAndGroupsForm: React.FC<IAssignEmployeesAndGroupsFormProps> = ({ onClose, formData }) => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const { status, mutateAsync } = useBulkAssignEmployeesAndGroups();

  const handleFormSubmit = (values: typeof initialAssignEmployeesAndGroupsData) => {
    const postData = {
      id: values.id,
      all_users: values.all_users,
      user_ids: values.user_ids ? values.user_ids.map((user: any) => user.userId) : [],
      group_ids: values.group_ids ? values.group_ids.map((group: any) => group.id) : [],
    };

    mutateAsync(postData).then(() => {
      onClose();
    });
  };

  return (
    <>
      <DrawerHeader>{t('jobsTasks:assignTo')}</DrawerHeader>
      <DrawerBody>
        <Divider mb="6" />
        <Formik enableReinitialize initialValues={formData} onSubmit={handleFormSubmit}>
          {() => (
            <Form noValidate>
              <Text as="h4" textTransform="uppercase" size="md" fontWeight="semibold" mb="2">
                {t('common:users')}
              </Text>
              <EmployeeList boxHeight="calc(55vh - 215px)" fieldName="user_ids" />
              <Divider my="6" />
              <Text as="h4" textTransform="uppercase" size="md" fontWeight="semibold" mb="1">
                {t('common:usersGroups')}
              </Text>
              <Text fontSize="13px" mb="2" color="gray.500">
                {t('jobsTasks:useThisFieldToSelectGroupRelatedUsers')}.
              </Text>
              <EmployeeGroupInfiniteList
                boxHeight="calc(45vh - 230px)"
                employeeFieldName="user_ids"
                fieldName="group_ids"
              />
              <DrawerFixedButton>
                <Button type="submit" colorScheme="secondary" width="100%" size="lg" isLoading={status === 'loading'}>
                  {t('common:assignUser')}
                </Button>
              </DrawerFixedButton>
            </Form>
          )}
        </Formik>
      </DrawerBody>
    </>
  );
};

export default AssignEmployeesAndGroupsForm;
